// src/components/PillFilter.js
import React, { useState, useRef, useEffect } from "react";

const PillFilter = ({
    suggestions,      // [{id, label, ...}, ...]
    selected,         // [id, ...]
    onAdd,         // fn(id: string)
    onRemove,       // fn(id: string)
    renderPill,       // optional: fn(opt) → JSX
    renderSuggestion, // optional: fn(opt) → JSX
    placeholder = "Search…",
    isGrid = false,
}) => {
    const [query, setQuery] = useState("");
    const [isInputFocused, setIsInputFocused] = useState(false);
    const containerRef = useRef(null);
    const inputRef = useRef();

    //If Backspace & empty, remove last pill
    const handleKeyDown = e => {
        if (e.key === "Backspace" && query === "" && selected.length) {
            e.preventDefault();
            onRemove(selected[selected.length - 1]);
        }
    }

    // close dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(e) {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setIsInputFocused(false);
            }
        }
        document.addEventListener("pointerdown", handleClickOutside);
        return () => document.removeEventListener("pointerdown", handleClickOutside);
    }, []);

    // only show suggestions that aren’t already selected and match the query
    const matches = query
        ? suggestions
            .filter(opt => !selected.includes(opt.id))
            .filter(opt => opt.label.toLowerCase().includes(query.toLowerCase()))
        : suggestions.filter(opt => !selected.includes(opt.id));

    return (
        <div className="pill-filter" ref={containerRef} onClick={() => { inputRef.current.focus(); setIsInputFocused(true) }}>
            <div >
                {/* Render selected pills */}
                {selected
                .map(id => suggestions.find(o => o.id === id))
                .filter(Boolean)
                .map(opt =>
                    <button
                        className="pill"
                        aria-label={`Remove ${opt.id}`}
                        onPointerDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onRemove(opt.id)}}
                        key={opt.id}
                    >
                        {renderPill ? renderPill(opt) : <span >{opt.id}</span>}
                    </button>
                ).filter(Boolean)     }
                {/* The input */}
                <input
                    ref={inputRef}
                    value={query}
                    onChange={e => setQuery(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onFocus={() => setIsInputFocused(true)}
                    placeholder="Search…"
                />
            </div>

            {isInputFocused && matches.length > 0 && (
                <ul className={isGrid ? "pill-filter-grid" : "pill-filter-list"}>
                    {matches.map(opt => (
                            <li
                                key={opt.id}
                                onClick={() => {
                                    onAdd(opt.id);
                                    setQuery("");            // clear input
                                    setIsInputFocused(true); // keep list open
                                }}
                            >
                                {renderSuggestion ? renderSuggestion(opt) : <span >{opt.label}</span>}
                            </li>
                    )
                    )}
                </ul>
            )}
        </div>
    );
};

export default PillFilter;
